export const debounce = (cb: Function, delay: number) => {
let timeOut: any;
return (...args: any) => {
    clearTimeout(timeOut);
    timeOut = setTimeout(() => {
    cb(...args);
    }, delay);
};
};